import * as React from "react";
import "../../../../utils/number_extensions";
import { Typography } from '@mui/material';
import { useGlobalStores } from "../../../../hooks/use_global_stores";
import { ISnapshotV3 } from "../../../../config/snapshot";
import { periodPercentageComparisonV3 } from "../../../../helpers/snapshot_helpers";
import { ArrowCircleLeft, ArrowCircleRight } from "@mui/icons-material";
import { Amount, BlueContainer, DataContainer, PreviousPeriodContainer, PreviousPeriodIcon, Title } from "./MonthlyExpensesLayoutComponents";
import { MonthlyChart } from "./MonthlyChart";

interface IMonthlyExpensesProps {
    snapshot: ISnapshotV3;
}

export const MonthlyExpenses = ({snapshot}: IMonthlyExpensesProps) => {
    const { currencyStore } = useGlobalStores();

    return (
        <BlueContainer>
            <MonthlyChart snapshot={snapshot} />

            <DataContainer>
                <Title variant="button">
                    Expenses This Month
                </Title>
                <Amount variant="h2">
                    {(Math.round(snapshot.amount) as any).toCurrency(currencyStore.currentCurrency, {minimumFractionDigits: 0})}
                </Amount>

                <PreviousPeriodContainer>
                    <PreviousPeriodIcon>
                        {snapshot.amount_difference > 0 ? <ArrowCircleLeft /> : <ArrowCircleRight />}
                    </PreviousPeriodIcon>

                    <Typography variant="button">
                        {periodPercentageComparisonV3(snapshot.amount_difference)} from last month
                    </Typography>
                </PreviousPeriodContainer>
            </DataContainer>
        </BlueContainer>
    );
};
